<template>
  <div class="infoList" :style="{width:info.width, height:info.width}">
    <div class="title">
      <Icon :type="info.icon" :size="info.size" :color="info.color" :custom="info.custom" />
      <span>{{info.title}}</span>
      <div class="title-r">
        <a class="all" @click="toPromacti">更多>></a>
      </div>
    </div>
    <div
      class="list"
      v-for="(list , index) in info.infos"
      :key="index"
      @click="toTableClick(list.ID, list.PM_C_PROM_TYPE_ID)"
    >
      <Icon style="vertical-align: top; color: #666;" type="ios-radio-button-on" size="10" />
      <a class="info">{{list.ENAME}}</a>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
export default {
  data() {
    return {
      // info:{
      //     icon:'md-appstore',
      //     size: '30',
      //     color: '',
      //     custom: '',
      //     title: '促销活动',
      //     width: '200px',
      //     height: '500px',
      //     infos:['京东双12前30分钟买一送一','天猫冰雪节399赠送袜子','京东圣诞节鞋子送袜子','双12天猫满599随机赠送礼']
      //     name: 文件名（通过文件名处理各自页面的跳转逻辑）
      // }
    };
  },
  props: {
    info: {
      type: Object
    }
  },
  methods: {
    toPromacti() {
      if (this.info.name === 'customerServiceWorkbench') { // 客服工作台跳转
        this.$store.commit("TabOpen", {
          id: 2663, //单据id
          type: "action", //类型action
          name: "promactiquerylist", //文件名
          label: "促销活动", //tab中文名
          query: Object.assign({
            id: 2663, //单据id
          }) //带的参数
        });
      }else if(this.info.name === 'logisticWorkbench'){//物流工作台跳转
        this.$store.commit("TabOpen", {
          id: 24600,
          type: "table",
          name: "ST_C_EXPRESS",
          label: "物流方案",
          back:true,
          query: Object.assign({
            id: -1,
            tabTitle: "物流方案"
          })
        });
      }
    },
    toTableClick(id, typeId) {
      if (this.info.name === 'customerServiceWorkbench') { // 客服工作台跳转
        this.axios({
          method: 'post',
          url: '/p/cs/cpromactiquery',
          data: {
            param:JSON.stringify({
              "objid": id,  "prom_type_id": typeId
            })
          }
        }).then((res) => {
          if(res.data.code===0){
            this.$store.state.dataTwo=res.data.data
            // sq存储一套作为清空操作的初始数据
            let scheme_dataInit = JSON.stringify(res.data.data.scheme_arr);
            this.$store.commit('scheme_dataRecover' , JSON.parse(scheme_dataInit));
            // 存储种类id保存草稿时需要
            this.$store.state.jordanStore.sch_type_id = res.data.data.basic_info.sch_type_id
            this.$store.commit('TabOpen', {
              id: id, // id
              type: "action", // 类型action
              name: "promotion", // 文件名
              label: "编辑促销活动", // tab中文名
              query: Object.assign({
                id: id, // id
                typeId: typeId,
                tabTitle: "编辑促销活动", // tab中文名
                prom_type_name: '商品线上买赠', // 二类名称
                prom_type_brief: '针对某类商品，满X件或X元，赠送Y商品',  // 二类描述
                status: 1
              })//带的参数
            })
          }
        })
      }else if(this.info.name === 'logisticWorkbench'){//物流工作台跳转
        this.$store.commit("TabOpen", {
          id: id,
          type: "singleView", //类型action
          name: "singleView",
          label: "物流方案", //tab中文名
          query: {
            id: id,
            pid: "24600",
            ptitle: "物流方案",
            ptype: "table",
            tabTitle: "物流方案",
            tableName: "ST_C_EXPRESS"
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.infoList {
  padding-left: 5px;
  background-color: #fafafa;
  overflow: hidden;
}
.infoList .title {
  position: relative;
  height: 30px;
  line-height: 30px;
  color: #fd6442;
  font-size: 14px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.title .title-r {
  position: absolute;
  right: 10px;
  top: 0;
}
.title .title-r .all {
  font-size: 12px;
  width: 100%;
  text-align: right;
  color: #999;
}
.title .title-r .all:hover {
  color: #fd6442;
}
.infoList .list {
  margin-top: 12px;
  display: flex;
  cursor: pointer;
}
.infoList .info {
  padding-left: 3px;
  width: 100%;
  font-size: 12px;
  color: #999;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.infoList .info:hover {
  color: #fd6442;
}
.infoList .ark-icon {
  padding-bottom: 5px;
}
</style>
